/**
 * Alias chartType LLM → enum Zod (bar|pie|line|dot|table).
 * (B) Solo normaliza aliases conocidos; no debilita el enum.
 */

export const DATA_CHART_TYPE_ALIASES = Object.freeze({
  bar: 'bar',
  bars: 'bar',
  barra: 'bar',
  barras: 'bar',
  column: 'bar',
  columns: 'bar',
  columnar: 'bar',
  histogram: 'bar',
  histograma: 'bar',
  pie: 'pie',
  pastel: 'pie',
  circle: 'pie',
  donut: 'pie',
  line: 'line',
  lines: 'line',
  linear: 'line',
  linea: 'line',
  scatter: 'dot',
  dots: 'dot',
  dot: 'dot',
  points: 'dot',
  table: 'table',
  tabular: 'table',
  spreadsheet: 'table',
  grid: 'table',
} as const);

export type CanonicalDataChartType = 'bar' | 'pie' | 'line' | 'dot' | 'table';

export function normalizeDataChartType(raw: unknown): CanonicalDataChartType | null {
  const key = String(raw ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  if (!key) return null;
  return (DATA_CHART_TYPE_ALIASES as Record<string, CanonicalDataChartType>)[key] ?? null;
}

export function coerceDataChartPayloadChartType(raw: unknown): unknown {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return raw;
  const payload = { ...(raw as Record<string, unknown>) };
  const normalized = normalizeDataChartType(payload.chartType);
  if (normalized) {
    payload.chartType = normalized;
  }
  return payload;
}
